import { ListItemIcon, ListItemText, MenuItem } from '@material-ui/core';

export const OptionsItem = ({ handleClick, icon, iconName, color, title }) => {
  return (
    <MenuItem onClick={handleClick} sx={{ color: color || 'text.secondary' }}>
      <ListItemIcon>{icon ? icon : <Icon icon={iconName} width={24} height={24} />}</ListItemIcon>
      <ListItemText primary={title} primaryTypographyProps={{ variant: 'body2' }} />
    </MenuItem>
  );
};
